import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";

const PieChartComponent = ({ data,colors }) => {
  let mapData = [];
  let hasData = false;
  if (data && data.length > 0) {
    mapData = data.map(({ StageName, total_count }) => ({
      name: StageName,
      value: total_count,
      color: colors[StageName], 
    }));
    // Check if there's at least one non-zero value
    hasData = mapData.some(item => item.value > 0);
  }

  const defaultData = [{ name: "No Data", value: 1 }];

  const DEFAULT_COLOR = "#dddddd"; // Default color for no data

  // Custom tooltip content rendering function
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        const data = payload[0].payload;
        return (
            <div style={{
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                padding: '5px',
                borderRadius: '5px'
            }}>
                <p>{data.name}</p>
                <p><strong>Count:</strong> {data.value}</p>
            </div>
        );
    }

    return null;
};

  return (
    <div>
      <PieChart width={345} height={345}>
        <Pie
          dataKey="value"
          data={hasData ? mapData : defaultData}
          cx={150}
          cy={150}
          outerRadius={140}
          innerRadius={90}
          fill="#8884d8"
          // onMouseEnter={(e) => {
          //           console.log(e); // For debug or additional interactive effects
          //       }}
        //    label
        >
          {(hasData ? mapData : defaultData).map((entry, index) => (
            <Cell key={`cell-${index}`} fill={hasData && entry.color ? entry.color : DEFAULT_COLOR} />
          ))}
        
        </Pie>
        <Tooltip content={<CustomTooltip />} />
      </PieChart>
    </div>
  );
};

export default PieChartComponent;